<div class=" asset profile-authentication-area ptb-100">
    <div class="container">
        <div class="row ">
            <div class="col-lg-6 col-md-12">
                <div class="get-instant-courses-image"><img src="assets/img/join.png" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="login-form">
                    <h2 class="level-title">Réinitialiser le mot de passe</h2>
                    <form [formGroup]="resetPassword" ngNativeValidate (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label>Adresse Email</label>
                            <input required formControlName="email" name="email" type="text" class="form-control">
                        </div>
                        <div *ngIf="error || message"
                            [ngClass]="{'text-danger':error,'text-success':message, 'bg-danger':error,'bg-success':message}"
                            class="card" style="margin-top:24px;">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item" [ngClass]="{'text-danger':error,'text-success':message}">
                                    {{error||message}}
                                </li>
                            </ul>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-6 col-sm-6 remember-me-wrap">
                                <p>

                                </p>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-6 lost-your-password-wrap">
                                <a [routerLink]="'/'" class="lost-your-password">Accueil</a>
                            </div>
                        </div>
                        <button type="submit" [disabled]="showSpinner" class="btn btn-success"
                            type="submit">valider<span *ngIf="showSpinner"
                                class="spinner-border spinner"></span></button>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>